export default __webpack_public_path__ + "static/media/service7.2c5c00ec.jpg";